// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__XUM-Y","label":"LabeledBox_label__3fVhi"};